import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
});

const inputStyle = {
    width: '100%', padding: '9px 11px', borderRadius: '7px',
    border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box'
};
const labelStyle = { display: 'block', fontWeight: 600, marginBottom: '5px', fontSize: '13px' };
const btn = (bg, color = '#fff') => ({
    background: bg, color, border: 'none', borderRadius: '8px',
    padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: '13px'
});
const card = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', marginBottom: '20px' };

const fmtDate = (s) => (s ? new Date(s.replace(' ', 'T') + 'Z').toLocaleString() : '—');

const NOT_GENERATED_TR = 'FieldClimate bu hesap için gizli anahtarı henüz oluşturmamış (sayfada "undefined" yazıyor). METOS desteğinden API erişiminin açılmasını isteyin.';

const errorTextFor = (tr) => (data, status) =>
    (tr && data.code === 'SECRET_NOT_GENERATED') ? NOT_GENERATED_TR : (data.error || `HTTP ${status}`);

const FieldClimatePanel = ({ tr, fields = [], defaultFieldId, onSensorsChanged }) => {
    const [method, setMethod] = useState('oauth');
    const errorText = errorTextFor(tr);
    const [cred, setCred] = useState({ clientId: '', clientSecret: '', username: '', password: '', publicKey: '', privateKey: '' });
    const setField = (k) => (e) => setCred(c => ({ ...c, [k]: e.target.value }));
    const credentialBody = () => (method === 'oauth'
        ? { method, clientId: cred.clientId, clientSecret: cred.clientSecret, username: cred.username, password: cred.password }
        : { method, publicKey: cred.publicKey, privateKey: cred.privateKey });
    const canConnect = method === 'oauth' ? cred.clientId && cred.clientSecret : cred.publicKey && cred.privateKey;
    const [stations, setStations] = useState([]);
    const [selected, setSelected] = useState(new Set());
    const [fieldId, setFieldId] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [saved, setSaved] = useState([]);

    useEffect(() => {
        const preferred = fields.find(f => /karg[ıi]cak_irrigation/i.test(f.name || ''));
        setFieldId(String(preferred?.id || defaultFieldId || ''));
    }, [fields, defaultFieldId]);

    const loadSaved = async () => {
        try {
            const res = await fetch(`${API_URL}/sensors`, { headers: getHeaders() });
            if (!res.ok) return;
            const all = await res.json();
            setSaved(all.filter(s => s.fieldclimateStationId));
        } catch { /* list stays as-is */ }
    };
    useEffect(() => { loadSaved(); }, []);

    const connect = async () => {
        setError(null); setSuccess(null); setBusy(true);
        try {
            const res = await fetch(`${API_URL}/proxy/fieldclimate/stations`, {
                method: 'POST', headers: getHeaders(),
                body: JSON.stringify(credentialBody()),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(errorText(data, res.status));
            setStations(data);
            setSelected(new Set(data.length === 1 ? [data[0].id] : []));
            if (data.length === 0) setError(tr ? 'Bu hesapta istasyon bulunamadı.' : 'No stations found on this account.');
        } catch (e) {
            setError(e.message);
        } finally {
            setBusy(false);
        }
    };

    const importStations = async () => {
        setError(null); setSuccess(null); setBusy(true);
        try {
            const res = await fetch(`${API_URL}/proxy/fieldclimate/import`, {
                method: 'POST', headers: getHeaders(),
                body: JSON.stringify({
                    ...credentialBody(), fieldId,
                    stations: stations.filter(s => selected.has(s.id)),
                }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(errorText(data, res.status));
            setSuccess(tr
                ? `${data.count} istasyon kaydedildi. Son 30 günün verisi arka planda çekiliyor; sonra her 15 dakikada güncellenir.`
                : `${data.count} station(s) saved. The last 30 days are being fetched in the background; then updates every 15 minutes.`);
            setStations([]); setSelected(new Set());
            setCred(c => ({ ...c, clientSecret: '', password: '', privateKey: '' }));
            loadSaved();
            onSensorsChanged?.();
        } catch (e) {
            setError(e.message);
        } finally {
            setBusy(false);
        }
    };

    const remove = async (s) => {
        if (!window.confirm(tr ? `"${s.name}" silinsin mi? Kayıtlı ölçümleri de silinir.` : `Delete "${s.name}"? Its stored readings are deleted too.`)) return;
        const res = await fetch(`${API_URL}/sensors/${s.id}`, { method: 'DELETE', headers: getHeaders() });
        if (res.ok) { loadSaved(); onSensorsChanged?.(); }
        else setError(tr ? 'Silinemedi.' : 'Delete failed.');
    };

    const toggle = (id) => setSelected(prev => {
        const next = new Set(prev);
        next.has(id) ? next.delete(id) : next.add(id);
        return next;
    });

    return (
        <div>
            <div style={card}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
                    FieldClimate (METOS) {tr ? 'Bağlantısı' : 'Connection'}
                </div>
                <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 14 }}>
                    {tr
                        ? 'FieldClimate → Kullanıcı menüsü → API services. Gizli bilgiler şifrelenerek saklanır ve tarayıcıya geri gönderilmez.'
                        : 'FieldClimate → User menu → API services. Secrets are stored encrypted and never sent back to the browser.'}
                </div>

                <div role="radiogroup" style={{ display: 'flex', gap: 16, marginBottom: 14, fontSize: 13, fontWeight: 600 }}>
                    {[{ id: 'oauth', label: 'OAuth 2.0' }, { id: 'hmac', label: 'HMAC' }].map(m => (
                        <label key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                            <input type="radio" name="fc-method" checked={method === m.id} onChange={() => { setMethod(m.id); setError(null); }} />
                            {m.label}
                        </label>
                    ))}
                </div>

                {method === 'oauth' ? (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                        <div>
                            <label style={labelStyle}>{tr ? 'Kullanıcı ID (Client ID)' : 'Client ID'}</label>
                            <input style={inputStyle} value={cred.clientId} onChange={setField('clientId')} autoComplete="off" />
                        </div>
                        <div>
                            <label style={labelStyle}>{tr ? 'Gizli Kullanıcı (Client secret)' : 'Client secret'}</label>
                            <input style={inputStyle} type="password" value={cred.clientSecret} onChange={setField('clientSecret')} autoComplete="new-password" />
                        </div>
                        <div>
                            <label style={labelStyle}>{tr ? 'FieldClimate kullanıcı adı (isteğe bağlı)' : 'FieldClimate username (optional)'}</label>
                            <input style={inputStyle} value={cred.username} onChange={setField('username')} autoComplete="off" />
                        </div>
                        <div>
                            <label style={labelStyle}>{tr ? 'FieldClimate şifresi (isteğe bağlı)' : 'FieldClimate password (optional)'}</label>
                            <input style={inputStyle} type="password" value={cred.password} onChange={setField('password')} autoComplete="new-password" />
                        </div>
                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                        <div>
                            <label style={labelStyle}>{tr ? 'Genel anahtar (Public key)' : 'Public key'}</label>
                            <input style={inputStyle} value={cred.publicKey} onChange={setField('publicKey')} autoComplete="off" />
                        </div>
                        <div>
                            <label style={labelStyle}>{tr ? 'Özel anahtar (Private key)' : 'Private key'}</label>
                            <input style={inputStyle} type="password" value={cred.privateKey} onChange={setField('privateKey')} autoComplete="new-password" />
                        </div>
                    </div>
                )}

                <button style={btn('#4f46e5')} disabled={busy || !canConnect} onClick={connect}>
                    {busy && stations.length === 0 ? (tr ? 'Bağlanıyor…' : 'Connecting…') : (tr ? 'Bağlan ve istasyonları listele' : 'Connect and list stations')}
                </button>

                {error && <div style={{ marginTop: 12, color: '#b91c1c', fontSize: 13 }}>{error}</div>}
                {success && <div style={{ marginTop: 12, color: '#166534', fontSize: 13 }}>{success}</div>}
            </div>

            {stations.length > 0 && (
                <div style={card}>
                    <div style={{ fontWeight: 700, marginBottom: 12 }}>
                        {tr ? 'İstasyonlar' : 'Stations'} ({stations.length})
                    </div>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
                            <thead>
                                <tr style={{ textAlign: 'left', color: '#6b7280' }}>
                                    <th style={{ padding: 6 }} />
                                    <th style={{ padding: 6 }}>{tr ? 'Ad' : 'Name'}</th>
                                    <th style={{ padding: 6 }}>ID</th>
                                    <th style={{ padding: 6 }}>{tr ? 'Konum' : 'Location'}</th>
                                    <th style={{ padding: 6 }}>{tr ? 'Son veri' : 'Last data'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stations.map(s => (
                                    <tr key={s.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: 6 }}>
                                            <input type="checkbox" checked={selected.has(s.id)} onChange={() => toggle(s.id)} aria-label={s.name} />
                                        </td>
                                        <td style={{ padding: 6, fontWeight: 600 }}>{s.name}</td>
                                        <td style={{ padding: 6, fontFamily: 'monospace' }}>{s.id}</td>
                                        <td style={{ padding: 6, fontVariantNumeric: 'tabular-nums' }}>
                                            {s.lat != null ? `${Number(s.lat).toFixed(4)}, ${Number(s.lng).toFixed(4)}` : '—'}
                                        </td>
                                        <td style={{ padding: 6 }}>{fmtDate(s.maxDate)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', marginTop: 16, flexWrap: 'wrap' }}>
                        <div style={{ minWidth: 260 }}>
                            <label style={labelStyle}>{tr ? 'Tarla' : 'Field'}</label>
                            <select style={inputStyle} value={fieldId} onChange={e => setFieldId(e.target.value)}>
                                <option value="">{tr ? '— Tarla seçin —' : '— Select field —'}</option>
                                {fields.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
                            </select>
                        </div>
                        <button style={btn('#2d7a2d')} disabled={busy || selected.size === 0 || !fieldId} onClick={importStations}>
                            {busy ? (tr ? 'Kaydediliyor…' : 'Saving…') : (tr ? `${selected.size} istasyonu içe aktar` : `Import ${selected.size} station(s)`)}
                        </button>
                    </div>
                </div>
            )}

            <div style={card}>
                <div style={{ fontWeight: 700, marginBottom: 12 }}>
                    {tr ? 'Kayıtlı FieldClimate istasyonları' : 'Saved FieldClimate stations'} ({saved.length})
                </div>
                {saved.length === 0 ? (
                    <div style={{ fontSize: 13, color: '#6b7280' }}>
                        {tr ? 'Henüz istasyon yok. Yukarıdan bağlanıp içe aktarın.' : 'No stations yet. Connect and import above.'}
                    </div>
                ) : saved.map(s => (
                    <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderTop: '1px solid #f1f5f9', gap: 12 }}>
                        <div>
                            <div style={{ fontWeight: 600 }}>{s.name}</div>
                            <div style={{ fontSize: 12, color: '#6b7280' }}>
                                {fields.find(f => f.id === s.fieldId)?.name || '—'} · ID {s.fieldclimateStationId} · {tr ? 'Son senkron' : 'Last sync'}: {s.fieldclimateLastSync ? new Date(s.fieldclimateLastSync).toLocaleString() : (tr ? 'bekleniyor' : 'pending')}
                            </div>
                        </div>
                        <button style={btn('#fee2e2', '#b91c1c')} onClick={() => remove(s)}>{tr ? 'Sil' : 'Delete'}</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FieldClimatePanel;
